
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 4a11.93 11.93 0 019 4.094V5h2v7h-7v-2h3.938C22.134 7.59 19.241 6 16 6c-4.289 0-7.823 2.639-9.281 6.375l-1.844-.75C6.617 7.161 10.889 4 16 4zm9.281 15.625l1.844.75C25.383 24.839 21.111 28 16 28c-3.605 0-6.811-1.614-9-4.094V27H5v-7h7v2H8.031c1.812 2.388 4.692 4 7.969 4 4.289 0 7.823-2.639 9.281-6.375z"}})])
          )
        }
      }
    